import { useDoctorProfile } from 'reactQuery/queries';

const useReadOnlyUser = () => {
  const { data } = useDoctorProfile();

  let isReadOnlyUser = false;

  if (data && data?.pcUserRole && data?.pcUserRole.length > 0) {
    isReadOnlyUser = data.pcUserRole.includes('SalesReadOnlyUserRole');
  }

  return { isReadOnlyUser };
};

export default useReadOnlyUser;
